var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "platsysCategory:add",
                  expression: "'platsysCategory:add'"
                }
              ],
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("a-table", {
            ref: "table",
            attrs: {
              size: "middle",
              rowKey: "id",
              bordered: "",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              expandedRowKeys: _vm.expandedRowKeys
            },
            on: { change: _vm.handleTableChange, expand: _vm.handleExpand },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    { ref: "action" },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "platsysCategory:edit",
                              expression: "'platsysCategory:edit'"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["common.edit"]))]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-popconfirm",
                        {
                          attrs: {
                            title: _vm.language["common.deleteConfirmInfo"],
                            okText: _vm.language["common.okButton"],
                            cancelText: _vm.language["common.cancel"]
                          },
                          on: {
                            confirm: function() {
                              return _vm.handleDelete(record)
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value: "platsysCategory:delete",
                                  expression: "'platsysCategory:delete'"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.language["common.delete"]))]
                          )
                        ]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "platsysCategory:addLowerLevel",
                              expression: "'platsysCategory:addLowerLevel'"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.handleAddSub(record)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["addLowerLevel"]))]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("sys-category-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }